import React from "react";

export const Header = () => {
  return (
    <div>
      <h2>Budget Tracker</h2>
    </div>
  );
};
